<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__horiz sp-margin__bottom sp-color__primary">
    <qrcode
      class="sp-hidden__after-md sp-qrcode"
      #parent
      [qrdata]="getQRCodeData()"
      [allowEmptyString]="true"
      [cssClass]="'center'"
      [colorDark]="'#000000ff'"
      [colorLight]="'#ffffffff'"
      [elementType]="'canvas'"
      [errorCorrectionLevel]="'M'"
      [margin]="4"
      [scale]="1"
      [width]="200"></qrcode>
    <qrcode
      class="sp-hidden__before-md sp-qrcode"
      #parent
      [qrdata]="getQRCodeData()"
      [allowEmptyString]="true"
      [cssClass]="'center'"
      [colorDark]="'#000000ff'"
      [colorLight]="'#ffffffff'"
      [elementType]="'canvas'"
      [errorCorrectionLevel]="'M'"
      [margin]="4"
      [scale]="1"
      [width]="350"></qrcode>

    <div class="sp-row__align sp-margin__bottom sp-dialog__max-width-s sp-padding__horiz">
      <button
        mat-icon-button
        [matTooltip]="'GENERAL.COPY_CTA' | translate"
        (click)="onCopyClick()"
        class="sp-icon__button sp-icon__button-accent">
        <mat-icon> content_copy </mat-icon>
      </button>
      <p class="sp-margin__no sp-margin__left-x2 sp-text__ellipsized">
        {{ getQRCodeData() }}
      </p>
    </div>

    <div class="sp-padding__horiz sp-margin__top-x2 sp-margin__bottom-x2">
      <app-shared-button
        class="sp-width__full"
        [cta]="'Download'"
        [icon]="'download'"
        (button_click)="onDownloadQRCodeClick(parent)"></app-shared-button>
    </div>
  </div>
</div>
